import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { reviewLoginCart } from '../../../helpers/shop/loginCart';
import { clearRdrPage } from '../../../actions/user';
import { CartMergeReviewDialog } from './CartMergeReviewDialog';
export { CartMergeReviewDialog } from './CartMergeReviewDialog';

const CartMergeReview = () => {
    const { cart, login_cart_review: review, shipping: { methods: { selected } } } = useSelector(state => state.shop);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const finish = path => {
        navigate(path, { replace: true });
        dispatch(clearRdrPage());
        dispatch(reviewLoginCart());
    };
    return <CartMergeReviewDialog review={review} cart={cart} shipping={selected}
        onContinue={() => finish('/checkout')} onReview={() => finish('/carrito')} />;
};
export default CartMergeReview;
